var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"to-top-icon",attrs:{"href":"javascript:void(0)"},on:{"click":_vm.scrollToTop}})}
var staticRenderFns = []

export { render, staticRenderFns }